module.exports = __webpack_public_path__ + "static/img/1.33ed84c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/4/1.png
// module id = jylL
// module chunks = 0